import { Box, MenuItem } from "@mui/material";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import { styled } from "@mui/material/styles";
import { useColors } from "../../../../Context/ColorsContext";
import { MediaQuerys } from "../../../../styles/GlobalStyle";
import { ContainerInputsDate } from "../../../../pages/styles";

const { mobile, tablet ,desktop } = MediaQuerys;

export const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  width: '550px',
  height: '100%',
  flexDirection: 'column',
  [theme.breakpoints.down('md')]: {
    width: '76vw',
  },
  [theme.breakpoints.down('sm')]: {
    width: '90vw',
  },
}))

export const Header = styled('div')(() => {
  const { colors } = useColors();
  return {
    display: 'flex',
    background: colors.white,
    color: colors.sidebarSelectColor,
    width: '100%',
    height: 'fit-content',
    borderRadius:'10px 10px 0 0',
    padding:'16px',
    textTransform:'uppercase',
    fontWeight:600,
    fontSize: '14px',
    [tablet]: {
      fontSize: '12px',
    },
  }
})

export const Body = styled('div')(() => {
  const { colors } = useColors();
  return {
    display: 'flex',
    flexDirection:'column',
    flex:'1',
    width: '100%',
    background: colors.white,
    padding: '10px 30px 30px',
  }
})

export const Footer = styled('div')(() => {
  const { colors } = useColors();
  return {
    display: 'flex',
    background: colors.white,
    width: '100%',
    height: 'fit-content',
    borderRadius:'0 0 10px 10px',
    justifyContent: 'flex-end',
    alignItems: 'center',
    padding: '16px',
    margin: 'auto'
  }
})

export const SectionRight = styled('section')(() => ({
  display: 'flex',
  gap: '1rem',
}))

export const BoxContainer = styled(Box)(({theme}) => {
    return {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        gap: 6,
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
        },
    }
})

export const MenuNotification = styled(MenuItem)(() => {
    const { colors } = useColors();
    return {
        borderBottom: `1px solid ${colors.gray}`
    }
})


export const ContainerDates = styled('div')(() => {
  return {
    display: "flex",
    flexDirection: 'column',
  }
})


export const ContainerGroup = styled("div")(({ needMagin, theme }) => {
  return {
    display: "flex",
    alignItems: "center",
    gap: 6,
    flexDirection: "row",
    marginLeft: needMagin && 5,
  };
});

export const CleanIcon = styled(CleaningServicesIcon)(() => {
  const { colors } = useColors();
  return {
      color: colors.white,
      fontSize: 18,
      [tablet]: {
          width: 17,
          height: 17,
          padding: '1px',
          '.MuiSvgIcon-root': {
              width: 16,
              height: 16,
          }
      },
      [desktop]: {
          width: '16px',
          height: '16px',
      }
  };
});

export const InputsDate = styled(ContainerInputsDate)(({theme, errorstart, errorend}) => {
  return {
    '& .MuiButtonBase-root': {
      color: (errorstart || errorend) ? theme.palette.error.main : 'inherit', 
    },
    width: '50%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    }
  }
});